import React, { useEffect, useState } from 'react'
import '../../styles/style.css';
import '../../styles/navbar.css';
import '../../styles/adminrole.css'
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";
import { BASE_URL, exceptThisSymbols } from '../../constant/Utility'

function Register() {


  const base_url = BASE_URL;
  // const base_url = 'http://127.0.0.1:8000/';

  const { register, formState: { errors }, handleSubmit, getValues } = useForm();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [type, setType] = useState(false);
  const [type1, setType1] = useState(false);
  const page_id = localStorage.getItem("page_id");

  var navigate = useNavigate();

  const onSubmit = (data) => {

    setLoading(true);
    delete data.confirmPassword;
    if(page_id == 0){
      data.user_type = "Karuna"
    }
    axios({
      url: base_url + 'user/register',
      method: 'post',
      data: data,
    }).then((response) => {
      setLoading(false);
      Swal.fire({
        title: '<h4>Registered successfully</h4>',
        text: 'Verify your email and continue to login',
        icon: 'success',
        showConfirmButton: false,
        timer: 3000
      });
      navigate('/login');
      
    }, error => {
      console.error("Register error:", error);
      setMessage(error?.response?.data?.detail || 'An error occurred during registration');
      setLoading(false);
    })

  }

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[message])

  const Loading = (status) => {
    if (status) {
      // document.body.setAttribute('style','overflow:hidden;height:100vh');
      return (
        <div className='app_content'>
          <div className="loading">Loading&#8230;</div>
        </div>
      )
    } else {
      document.body.setAttribute('style', 'overflow:visible;');
    }
  }


  return (
    <div className='karuna_part h-100'>
      <div>
        <section id="login_arae" className="section_padding h-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                <div className="section_heading text-w" style={{marginBottom:'0px'}}>
                  <h3>Register your account</h3>
                  <h2>Become a
                    <span className="color_big_heading"> member </span>
                    and enhance your hand
                  </h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 offset-lg-3">
                <div className="author_form_area">
                  <form onSubmit={handleSubmit(onSubmit)} id="author_form">
                  <h4 className="text-danger text-center mb-2">{message?.detail}</h4>
                    <div className="form-group">
                      <input
                        className="custum-control form-control"
                        placeholder="First Name *"
                        {...register("first_name", {
                          required: true, pattern: {
                            value: /^[A-Za-z]+$/,
                          }
                        })}
                        aria-invalid={errors.first_name ? "true" : "false"} />
                      {errors.first_name?.type === 'required' && <div className='text_danger'>First name is required</div>}
                      {errors.first_name?.type === "pattern" && <div className='text_danger '>Name can contain only alphabets</div>}
                    </div>
                    <div className="form-group mt-3">
                      <input type="text"
                        className="custum-control form-control"
                        placeholder="Last Name"
                        {...register("last_name", {
                          required: false, pattern: {
                            value: /^[A-Za-z ]+$/,
                          }
                        })}
                        aria-invalid={errors.last_name ? "true" : "false"} />
                      {errors.last_name?.type === "pattern" && <div className='text_danger '>Name can contain only alphabets</div>}
                    </div>

                    <div className="form-group mt-3">
                      <input type="text"
                        className="custum-control form-control"
                        placeholder="Email *"
                        {...register("email_id", { required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i })}
                        aria-invalid={errors.email_id ? "true" : "false"} />
                      {errors.email_id?.type === 'pattern' && <div className='text_danger'>Enter valid mail ID</div>}
                      {errors.email_id?.type === 'required' && <div className='text_danger'>Email ID is required</div>}
                    </div>

                    <div className="form-group mt-3">
                      <input type="number"
                        className="custum-control form-control"
                        placeholder="Mobile Number *"
                        onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                        {...register("mobile_no", { required: true, minLength: 10, maxLength: 12, pattern: /^[0-9\b]+$/ })}
                        aria-invalid={errors.mobile_no ? "true" : "false"} />
                      {errors.mobile_no?.type === 'pattern' && <div className='text_danger'>Enter valid mobile number</div>}
                      {errors.mobile_no?.type === 'minLength' && <div className='text_danger'>Enter valid mobile number</div>}
                      {errors.mobile_no?.type === 'maxLength' && <div className='text_danger'>Enter valid mobile number</div>}
                      {errors.mobile_no?.type === 'required' && <div className='text_danger'>Mobile number is required</div>}
                    </div>

                    <div className="form-group mt-3">
                      <div className='input-group'>
                        <input type={type ? "text" : "password"}
                          className="custum-control form-control"
                          placeholder="Password *"
                          {...register("password", { required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/ })}
                          aria-invalid={errors.password ? "true" : "false"} />
                        <span className='input-group-text custum-control'><i className={type ? "fas fa-eye-slash" : "fas fa-eye"} onClick={() => { setType(!type) }} style={{ cursor: 'pointer' }} ></i></span>
                      </div>
                      {errors.password?.type === 'required' && <div className='text_danger'>Password is required</div>}
                      {errors.password?.type === 'pattern' && <div className='text_danger'>
                        password field should contain <br />- at least one uppercase and one lowercase <br />- One special characters <br />- One number and minimum eight characters</div>}
                    </div>

                    <div className="form-group mt-3">
                      <div className='input-group'>
                        <input type={type1 ? "text" : "password"}
                          className="custum-control form-control"
                          placeholder="Confirm Password *"
                          {...register("confirmPassword", { required: true, validate: value => value === getValues("password") })}
                          aria-invalid={errors.confirmPassword ? "true" : "false"} />
                        <span className='input-group-text custum-control'><i className={type1 ? "fas fa-eye-slash" : "fas fa-eye"} onClick={() => { setType1(!type1) }} style={{ cursor: 'pointer' }} ></i></span>
                      </div>
                      {errors.confirmPassword?.type === 'required' && <div className='text_danger'> Confirm Password is required</div>}
                      {errors.confirmPassword?.type === 'validate' && <div className='text_danger'>Confirm password is mismatch</div>}

                    </div>

                    <div className="author_submit_form">
                      <button className="btn btn_theme btn_md" type='submit'>Sign Up</button>
                    </div>
                    <div className='text-center mt-3'>
                      <Link to="/login" className='link_login '>Back to Login</Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
      {Loading(loading)}
    </div>
  )
}

export default Register